import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate, Navigate, useLocation } from 'react-router-dom'
import BlockSelction from "./BlockSelection"
import Projects from '../../pages/maintems2page/Projects';
import { Link } from "react-router-dom"
import FilterPannerComponent from "../../components/projects/FilterPannerComponents"
import UpperNavBar from "../../components/upperNavBar"
import Navbar from "../Navbar"
import axios from "axios";
import blockZoneMapData from '../../block-zone.json';
import { useImperativeHandle, useRef} from 'react';
import { ReactSession } from 'react-client-session';
import {INVENTORY_2D_API, INVENTORY_2D_API_ACCESS_KEY} from "../../helper/constants";

const ProjectSlection = (props) => {
    const navigate = useNavigate();
    const [projectsLoading, setProjectsLoading] = useState(false);
    const [blocksLoading, setBlocksLoading] = useState(false);
    const [blockshow, setBlockShow] = useState([])
    const [blockSplittedArray, setBlockSplittedArray] = useState([])
    const location = useLocation()
    const [unitApartmentType, setUnitApartmentType] = useState([]);
    const [blockNames, setBlockNames] = useState({})
    var [buildUpArea, setBuildUpArea] = useState([23,91,149,192,594])
    var [allBedRooms, setAllBedRooms] = useState([])
    const [allBlocks, setAllBlocks] = useState([])
    const [currentBlock, setCurrentBlock] = useState('')
    const filterPannerComponentRef = useRef(null);
    var [startPrice, setSstartPrice] = useState(0);
    var [startPrice, setSstartPrice] = useState(0);
    var [endPrice, setEndPrice] = useState(0);
    var [currentPhase, setCurrentPhase] = useState(null)

    var [selectNBVal, setSelectNBVal] = useState(null)

    const buildUpAreaString = () => {
        const out = []
        buildUpArea.map((row, index) => {
            if (index < buildUpArea.length-1) {
                if(index>0) {
                    out.push((row+1)+"-"+buildUpArea[index+1])
                }else {
                    out.push(row+"-"+buildUpArea[index+1])
                }
            }
        })
        return out
    }
    const typeOfBedRooms = () => {
        const out={}

        return Object.keys(out).sort()
    }
    const svgLoad = () => {
        const objTag = document.querySelector('object')
        objTag.addEventListener('load', () => {
            if(ReactSession.get("data").length < 1) {
                    getData(objTag)
                } else {
                    handleJsonData(ReactSession.get("data"));
                }                    
        })

    }
    async function getData(objTag) {
        try {
            axios.defaults.headers.get['x-api-key'] = INVENTORY_2D_API_ACCESS_KEY
//            const res = await axios.get(`${INVENTORY_2D_API}?name=alya-konutlari-merkezefendi`);
            const res = await axios.get("assets/data/konaklariLocationPop.json");
            if (res.data) {
                var proj =res.data;
                if (Object.keys(blockNames).length === 0) {
                    handleJsonData(proj);
                }
    }
        } catch (error) {
        }
    }

    const deSelectAll = () =>  {
        const objTag = document.querySelector('object')
            Array.from(objTag.getSVGDocument().getElementsByTagName('path')).forEach(p => {
                p.setAttribute("visibility", "hidden");
            });
    }
    function findZone(phase,block)  {
        var data = ""
        Object.keys(blockZoneMapData).forEach(function(key) {
            const keyEle = key.split(",")
            if( keyEle[0].trim() === phase) {
                const start = Number(keyEle[1])
                const end = Number(keyEle[2])
                const current= Number(block.trim())
                if ((current >= start) && (current <= end)){
                    data = blockZoneMapData[key]
                    return 
                }
            }
        });
        return data
    } 
    const handleJsonData = (proj) => {
            deSelectAll()
            startPrice = undefined
            endPrice = undefined
            proj.data.inventories.forEach(unit => {
                var phase = unit.cubedotsId.split("-")[1];
                var block1 = unit.block;
                var zone = findZone(phase,unit.block)
                if (unit.status === "available" && zone === ReactSession.get("zone") ) {
                    var unitNo = unit.cubedotsId.split("-")[4];
                    const unitTypeArr = unit.unitType.split('_')
                    const buildArea = Number((unit.builtUpArea).toFixed())
                    var noOfBeds = unitTypeArr[0]
                    // remove 2-1 (A) to 2+2
                    noOfBeds = noOfBeds.split(' ')[0]
                    var typeOfBeds = unitTypeArr[1]
                    if( blockNames[zone] === undefined) {
                        blockNames[zone] = {}
                    }
                    if( blockNames[zone][block1] === undefined) {
                        blockNames[zone][block1] = {}
                    }
                    if( blockNames[zone][block1][unitNo] === undefined) {
                        blockNames[zone][block1][unitNo] = []
                    }
                    var current =  blockNames[zone][block1][unitNo]

                    // Bedroom Type
                    current.push( noOfBeds)
                    // Bedroom Type sub
                    current.push( typeOfBeds)

                    var select = -1
                    Array.from(buildUpArea).forEach( p => {
                        if (buildArea >= p) {
                            select++
                        }
                    })
                    current.push( buildUpArea[select])
                    current.push( unit.priceInUsd)

                    blockNames[zone][block1][unitNo] = current

                    if(startPrice === undefined) {
                        startPrice = endPrice = unit.priceInUsd
                    } else if (startPrice > unit.priceInUsd) {
                        startPrice = unit.priceInUsd
                    } else if (endPrice < unit.priceInUsd) {
                        endPrice = unit.priceInUsd
                    }
                }
            });
            filterPannerComponentRef.current.setPriceRange(startPrice,endPrice)
            updateSvgForBlockSelection({}, true)
            const  data = filterPannerComponentRef.current.getFilter(false)
            updateSvgForBlockSelection(data, true)
    }

    const updateSvgForBlockSelection =(filteredValue, firstTime) => {
        deSelectAll()
        var filterBlock = {}
        var noOfUnits = 0
        if (filteredValue === undefined) {
            filteredValue={}
        }
        var typeOfBedRooms = {}
        var areaOfBedRooms = {}
        var typeOfBedRoomsSub = {}
        var price = {}
        Object.keys(blockNames).map((zone, index1) => {
            var zoneSelect = false
            Object.keys(blockNames[zone]).map((block, index2) => {
             var blockSelect = false
             Object.keys(blockNames[zone][block]).map((unit, index3) => {
                 var select = 0
                 Object.keys(filteredValue).map((type,data) => {
                         var idx=0
                         console.log('log',filteredValue[type])
                         if(type == "NB") {
                             idx = 0
                             var w=0
                             Object.keys(filteredValue[type]).map((type1,dd) => {
                                 if(blockNames[zone][block][unit][idx] === filteredValue[type][type1]) {
                                     w = 1
                                 }                            
                             })
                             select += w
                         } else if(type == "TB") {
                             idx = 1
                             var w=0
                             Object.keys(filteredValue[type]).map((type1,dd) => {
                                 if(blockNames[zone][block][unit][idx] === filteredValue[type][type1]){
                                     w = 1
                                 }
                             })
                             select += w
                         } else if(type == "AB") {
                             idx = 2
                             var w=0
                             Object.keys(filteredValue[type]).map((type1,dd) => {
                                 const min = Number(filteredValue[type][type1].split('-')[0])
                                 const max = Number(filteredValue[type][type1].split('-')[1])
                                 if(blockNames[zone][block][unit][idx] >= min &&
                                    blockNames[zone][block][unit][idx] <= max ){
                                     w = 1
                                 }                            
                             })
                             select+=w
                         } else if(type == "R") {
                             idx = 3
                             const min = Number(filteredValue[type].split('-')[0])
                             const max = Number(filteredValue[type].split('-')[1])
                             if(blockNames[zone][block][unit][idx] >= min &&
                                blockNames[zone][block][unit][idx] <= max ){
                                 select++
                             }        
                             }
                         })
                     if( checkIsFilter(filteredValue,select)) {
                         blockSelect = true
                         noOfUnits++
                         typeOfBedRooms[blockNames[zone][block][unit][0]] = 1
                         typeOfBedRoomsSub[blockNames[zone][block][unit][1]] = 1
                         areaOfBedRooms[blockNames[zone][block][unit][2]] = 1
                         price[blockNames[zone][block][unit][3]] = 1
                     }
                     })
                    if (blockSelect) {
                        selectItem(zone + "_" +block)
                        allBedRooms.push(zone + "_" +block)
                    }
                })

            })
       filterPannerComponentRef.current.setAvailableUnits(noOfUnits)
       if(Object.keys(filteredValue).length == 0 && firstTime === true) {
        firstTimeSet(typeOfBedRooms,typeOfBedRoomsSub)
       }
    }
    const checkIsFilter = (filteredValue,select) => {
        var idx=0
        Object.keys(filteredValue).map((type1,d1) => {
            if(type1 == "R") {
                if(filteredValue[type1].length > 0) {
                    idx++
                }
            } else {
                var w=0
                Object.keys(filteredValue[type1]).map((type2,d2) => {
                    if(type2.length > 0) {
                        w=1
                    }
                })
                idx+=w
            }
        })
        return idx === select
    }    
    const firstTimeSet = (typeOfBedRooms,typeOfBedRoomsSub) => {
        var uniqueTags = [];
        Object.keys(typeOfBedRooms).map((data, index) => {
                if (uniqueTags.indexOf(data) === -1) {
                         uniqueTags.push(data)
            }
        })
        uniqueTags = uniqueTags.sort()
        filterPannerComponentRef.current.reSetTyoeOfBed(uniqueTags)
        uniqueTags = [];
         Object.keys(typeOfBedRoomsSub).map((data, index) => {
                 if (uniqueTags.indexOf(data) === -1) {
                         uniqueTags.push(data)
             }
         })
         filterPannerComponentRef.current.reSetTyoeOfBedSub(uniqueTags.sort())        
    }
    const selectNBComponent = (nb) => {
        setSelectNBVal(nb)
    }

    const selectItem = (item) => {
        const objTag = document.querySelector('object')
        var obj = objTag.getSVGDocument().getElementById(item);
        obj.setAttribute("visibility", "visible");
        obj.setAttribute('style', "display:inline;fill:#ffffff;fill-opacity:0.338191;stroke:#000000;stroke-width:0.322655;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0.5");
        obj.addEventListener('mouseover', handlePlaceClick);
        obj.addEventListener('mouseleave', handlePlaceOutClick);
        obj.addEventListener('click', onclickHandler);                 
        obj.setAttribute('cursor', 'pointer')
    }
    const handlePlaceClick = (ev) => {
        let t = ev.target;
        t.setAttribute('style', "display:inline;fill:#e4de3a;fill-opacity:0.638191;stroke:#000000;stroke-width:0.322655;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0.5");
    }
    const handlePlaceOutClick = (ev) => {
        let t = ev.target;
        t.setAttribute('style', "display:inline;fill:#ffffff;fill-opacity:0.338191;stroke:#000000;stroke-width:0.322655;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0.5");
    }

    const onclickHandler = (ev) => {
        let currentId = ev.target.getAttribute('id').split('_');
        ReactSession.set("phase", currentId[0])
        ReactSession.set("block", currentId[2])
        ReactSession.set("zone", currentId[0] + "_" + currentId[1])
        navigate("/blockSelction")
    }


    useEffect(() => {
        svgLoad();
    }, [])

    const backState = () => {
        setBlocksLoading(false)
    }
    const getSVG = () => {
        if( ReactSession.get("zone") === undefined) {
            ReactSession.setStoreType("localStorage");
        }
        return "assets/images/section_plan/" + ReactSession.get("zone").replace("_","") + "_HL.svg"
    }
    return (
        !blocksLoading ?
            <>
                    <Navbar />
                    <div className="projectslectionBox">
                    <UpperNavBar propArray={blockshow}/>
                    {
                    ReactSession.get("zone") !== null ? 
                    <div className="projectSelectionSection projectFilterSection">
                        <object
                            data={getSVG()}
                            aria-label="block view"
                        />
                            <FilterPannerComponent ref={filterPannerComponentRef} updateSvgForBlockSelection={(data) => { updateSvgForBlockSelection(data)}}
                                buildUpArea={buildUpAreaString()}
                                selectNBComponent={(tb) => selectNBComponent(tb)}
                                allBedRooms={allBedRooms}
                                />
                   </div>
                                : null
                            }
    
                </div>
            </>
            :
            <BlockSelction  currentBlock={currentBlock}  currentPhase={currentPhase} />
    )
}
export default ProjectSlection;